import React, {useEffect, useReducer} from 'react';
import {Button, Form, InputGroup, Modal} from '@themesberg/react-bootstrap';
import {FormattedMessage} from 'react-intl';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCopy, faEnvelope} from '@fortawesome/free-solid-svg-icons';
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import API from '../services/API';
import Utils from '../services/Utils';
import {useHistory} from 'react-router-dom';

export default (props) => {

  const formReducer = (state, event) => {
    if (event.value !== undefined) {
      return {
        ...state,
        [event.name]: event.value
      }
    } else {
      return event;
    }
  }

  const {intl, bookingId, show, onClose} = props;
  const history = useHistory();
  const [showShareModal, setShowShareModal] = React.useState(false);
  const [shareFormData, setShareFormData] = useReducer(formReducer, {});
  // Texte de la réservation pour WhatsApp, généré par le serveur (mêmes champs que l'email de partage).
  const [shareText, setShareText] = React.useState(null);

  useEffect(() => {
    setShowShareModal(show);
  }, [show]);

  // Chargé dès l'ouverture : le bouton WhatsApp est un vrai lien, un window.open après un appel
  // asynchrone serait bloqué comme popup.
  useEffect(() => {
    if (!show || !bookingId) {
      return;
    }
    let cancelled = false;
    setShareText(null);
    API.getAdminBookingShareText(history, bookingId).then(response => {
      if (!cancelled && response && response.data.success === true) {
        setShareText(response.data.data);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [show, bookingId, history]);

  const handleClose = () => {
    setShareFormData({});
    if (onClose) {
      onClose();
    }
    setShowShareModal(false);
  };

  const handleChange = event => {
    setShareFormData({
      name: event.target.id,
      value: event.target.value
    });
  }

  const handleShareBooking = (e) => {
    e.preventDefault();
    API.postShareAdminBooking(history, bookingId, shareFormData).then(response => {
      if (response && response.data.success === true) {
        Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'SENT_TO_YOUR_RECIPIENT'}));
        handleClose();
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  const handleCopyText = () => {
    navigator.clipboard.writeText(shareText).then(() => {
      Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'BOOKING_TEXT_COPIED'}));
    }, () => {
      Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
    });
  }

  // Sans numéro, wa.me laisse choisir le contact ou le groupe dans WhatsApp (mobile, Web ou Desktop).
  const whatsappUrl = shareText ? 'https://wa.me/?text=' + encodeURIComponent(shareText) : undefined;

  return (
    <Modal as={Modal.Dialog} centered show={showShareModal} onHide={() => handleClose()}>
      <Modal.Header>
        <Modal.Title className="h6"><FormattedMessage id="SHARE_WITH_COLLEAGUE"/></Modal.Title>
        <Button variant="close" aria-label="Close" onClick={() => handleClose()}/>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2"><FormattedMessage id="WHATSAPP_SHARE_HINT"/></p>
        <div className="d-flex flex-wrap gap-2">
          <Button as="a" href={whatsappUrl} target="_blank" rel="noopener noreferrer"
                  className={`cc-whatsapp-btn ${shareText ? '' : 'disabled'}`}
                  aria-disabled={!shareText}
                  onClick={() => shareText && handleClose()}>
            <FontAwesomeIcon icon={faWhatsapp} className="me-2"/>
            <FormattedMessage id="SHARE_VIA_WHATSAPP"/>
          </Button>
          <Button variant="light" disabled={!shareText} onClick={handleCopyText}>
            <FontAwesomeIcon icon={faCopy} className="me-2"/>
            <FormattedMessage id="COPY_TEXT"/>
          </Button>
        </div>

        <div className="d-flex align-items-center my-4 text-gray">
          <hr className="flex-grow-1 my-0"/>
          <span className="px-3 small"><FormattedMessage id="OR_BY_EMAIL"/></span>
          <hr className="flex-grow-1 my-0"/>
        </div>

        <Form id="share-form" onSubmit={handleShareBooking}>
          <Form.Group id="email" className="mb-4">
            <Form.Label><FormattedMessage id="EMAIL_ADDRESS"/></Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faEnvelope}/>
              </InputGroup.Text>
              <Form.Control required id="email"
                            type="email"
                            onChange={handleChange}
                            value={shareFormData.email}/>
            </InputGroup>
          </Form.Group>
          <FormattedMessage id="YOU_CAN_ATTACH_MSG_TO_RECIPIENT"/>
          <br/>
          <Form.Control as="textarea" rows="3" id="message"
                        onChange={handleChange} value={shareFormData.message}/>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" type="submit" form="share-form">
          <FormattedMessage id="SEND"/>
        </Button>
        <Button variant="link" className="text-gray ms-auto" onClick={() => handleClose()}>
          <FormattedMessage id="CLOSE"/>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
